import e from "@ui-components-3/ui/lib/components/Select";

import o from "../createFormikField/index.js";

const t = o(e, ((e, {setValue: o, setTouched: t}) => ({
    ...e,
    onChange: o,
    onBlur: t
})));

export { t as default };
//# sourceMappingURL=index.js.map
